
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/post/[postId]",
      function () {
        return require("private-next-pages/community/post/[postId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/post/[postId]"])
      });
    }
  